// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDoaL3UZFnCEL1hGGfWbJhIuSuREF1b9WI",
  authDomain: "eats-boost-my0f61.firebaseapp.com",
  projectId: "eats-boost-my0f61",
  storageBucket: "eats-boost-my0f61.firebasestorage.app",
  messagingSenderId: "1043345624805",
  appId: "1:1043345624805:web:2901a18b5e723c59868e0c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;
